/**
 * 抽獎流程五段的傳輸接縫。DOM 全留給呼叫端，這裡只負責把參數組成 request、
 * 送出、回傳 Promise<回應 JSON>。走 rest-client.mjs 共用的 REST 傳輸層。
 *
 * `draw/hold` 不收進來：它目前由既有的 `draw-hold.mjs` 的 `fetchHold()` 處理，
 * 收進來會改到既有 12 模組的介面。`lottery/server-time`、`lottery/board`、
 * `lottery/queue/extend` 不在抽獎流程五段內，維持原樣。
 */
import { createRestClient } from './rest-client.mjs';

/**
 * 折抵旗標轉成請求欄位。沒給旗標就一個欄位都不送——後端把缺席視為全開，
 * 舊呼叫端的行為因此不變。
 * @param {?{points?: boolean, return_points?: boolean}} flags
 * @returns {object}
 */
export function discountFields(flags) {
    if (!flags) {
        return {};
    }
    return {
        use_points: flags.points === false ? '0' : '1',
        use_return_points: flags.return_points === false ? '0' : '1',
    };
}

/**
 * @param {{restBase: string, nonce: string, request?: function}} opts
 * `request(method, route, params)` 預設用注入的 rest-client 送出，回傳 thenable。
 */
export function createDrawApi({ restBase, nonce, request }) {
    const client = createRestClient({ restBase, nonce, request });

    return {
        discountFields,
        quote(productId, selection, flags) {
            return client.post('/draw/quote', Object.assign({ product_id: productId, selection }, discountFields(flags)));
        },
        pointsOnlyDraw(productId, selection, flags, billingEmail, extraFields) {
            return client.post('/draw/points-only', Object.assign({ product_id: productId, selection, billing_email: billingEmail }, discountFields(flags), extraFields));
        },
        reserve(payload) {
            return client.post('/draw/reserve', payload);
        },
        card(payload) {
            return client.post('/draw/card', payload);
        },
        status(orderId) {
            return client.get('/draw/status', { order_id: orderId });
        },
        cancel(orderId) {
            return client.post('/draw/cancel', { order_id: orderId });
        },
    };
}
